<template>
  <div class="bad-request flex-all-center">{{ getSentence }}</div>
</template>

<script>
export default {
  props: {
    lang: {
      type: String,
    },
  },
  computed: {
    getSentence: function () {
      if (this.lang === "ja") {
        return "無効なリクエストです";
      } else {
        return "Invalid Request";
      }
    },
  },
  name: "BadRequest",
};
</script>

<style scoped>
.bad-request {
  height: calc(100vh - 286px);
}
</style>



// WEBPACK FOOTER //
// src/components/common/status/BadRequest.vue